<template>
    <div class="list-entry d-flex align-items-center" @click="handleClickAction" :class="{clickable: clickActionSet}">
        <img class="list-entry--image img-frame" :class="imageClasses"
             :src="$img(image, defaultImage)"
             onerror="this.style.visibility='hidden'"
        >

        <div class="list-entry--body d-flex">
            <div class="left-area flex-grow-1">
                <div class="list-entry--title text-truncate">
                    <slot name="title">
                        <div v-html="title" class="text-truncate"></div>
                    </slot>
                </div>

                <div class="list-entry--subtitle text-truncate">
                    <div v-html="subtitle"></div>
                </div>

                <div class="list-entry--content">
                    <slot name="content">
                        <div v-html="content"></div>
                    </slot>
                </div>
            </div>
            <slot name="right-area" />
        </div>

        <template v-if="actionCount">
            <btn theme="link" icon="dots-horizontal" class="list-entry--actions" @click.stop/>
            <popover auto-bind align-right>
                <navigation>
                    <template v-for="action of actions">
                        <nav-item :key="action.label"
                                  v-if="action.condition() || action.condition(entity)"
                                  :label="action.label"
                                  @click.stop="action.callback && action.callback(entity)"
                        />
                    </template>
                </navigation>
            </popover>
        </template>
    </div>
</template>

<style lang="scss">
    .list-entry {
        &.clickable {
            cursor: pointer;

            &:hover {
                color: $dark-red;
            }
        }

        .left-area {
            min-width: 0;
        }
    }

    .list-entry--image {
        flex-shrink: 0;
        margin-right: 15px;
        padding: 3px;
        border: 1px solid $dark-10;
        background-color: $white;
    }
    .list-entry--image__small {
        width: 60px;
        height: 60px;
    }
    .list-entry--image__big {
        width: 100px;
        height: 100px;
    }

    .list-entry--body{
        flex-grow: 1;
        flex-basis: 100%;
        min-width: 0;
    }

    .list-entry--title {
        font-weight: bold;
    }

    .list-entry--subtitle {
        color: $dark-70;
        font-size: $font-size-sm;
    }

    .list-entry--actions {
        margin-left: $spacer-2;
        height: 40px;
        line-height: 40px;

        &.btn-only-icon {
            width: 40px !important;
        }
    }

</style>

<script>
    export default {
        name: "ListEntry",

        props: {
            title: String,
            idImage: [String, Number],
            subtitle: String,
            content: String,
            clickAction: Function,
            actions: {type: Array, default: () => []},
            entity: {required: true, type: Object},
            defaultImage: String,
        },

        computed: {
            image() {
                return this.idImage ? this.idImage : this.entity.id_image;
            },

            imageClasses() {
                return typeof this.content === "undefined" ? "list-entry--image__small" : "list-entry--image__big";
            },

            clickActionSet() {
                return this.clickAction instanceof Function;
            },

            actionCount() {
                let result = 0;
                this.actions.forEach(e => {
                    if (e.condition && e.condition(this.entity)) {
                        result++;
                    }
                });
                return result;
            },
        },

        methods: {
            handleClickAction() {
                if (this.clickActionSet) {
                    this.clickAction(this.entity);
                }
            },
        },
    };
</script>